<template>
    <div id="PlayerOverview">
        <div class="section">
            <div class="row">
                <div class="col s12 m6 l4" v-for="player in players" v-bind:key="player.id">
                    <div class="card">
                        <div class="card-image">
                            <img v-if="player.playerImg" v-bind:src="player.playerImg">
                            <img v-else src="@/assets/placeholder.png">
                            <span class="card-title">{{player.playerName}}</span>
                            <router-link class="btn-floating halfway-fab waves-effect waves-light grey" v-bind:to="{name: 'PlayerEdit', params:{id: player.id} }">
                                <i class="material-icons">edit</i>
                            </router-link>
                        </div>
                        <div class="card-content">
                            <table style="width:100%">
                                <tr>
                                    <td><strong>Body Control</strong></td>
                                    <td>{{player.playerLevelBodyControl}}</td>
                                </tr>
                                <tr>
                                    <td><strong>Mental Control</strong></td>
                                    <td>{{player.playerLevelMentalControl}}</td>
                                </tr>
                                <tr>
                                    <td><strong>Fitness</strong></td>
                                    <td>{{player.playerLevelTechnique}}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="fixed-action-btn">
                <router-link to="/PlayerNew" class="btn-floating btn-large pulse">
                    <i class="material-icons">add</i>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>

import db from '../components/firebaseInit'

export default {
  name: 'PlayerOverview',
  data() {
    return {
      players: []
    }
  },
  created(){
      db.collection('players').orderBy('playerName').get().then(querySnapshot => {
          querySnapshot.forEach(doc => {
            //   console.log(doc.data());
              const data = {
                  'id': doc.id,
                  'playerImg': doc.data().playerImg,
                  'playerName': doc.data().playerName,
                  'playerLevelBodyControl': doc.data().playerLevelBodyControl,
                  'playerLevelMentalControl': doc.data().playerLevelMentalControl,
                  'playerLevelTechnique': doc.data().playerLevelTechnique
              }
              this.players.push(data)
          })
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/PlayerOverwiew.vue